import React from 'react';
import { AuthHeader } from './AuthHeader';
import { AuthFooter } from './AuthFooter';

interface AuthLayoutProps {
  children: React.ReactNode;
  showLoginLink?: boolean;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, showLoginLink = false }) => {
  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-white dark:bg-[#1a1a1a]">
      <div className="flex-1 lg:w-[50%] flex flex-col p-6 md:p-8 lg:p-12 bg-white dark:bg-[#242424]">
        {/* Header */}
        <AuthHeader showLoginLink={showLoginLink} />

        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center">
          <div className="w-full max-w-[468px]">
            {children}
          </div>
        </div>

        {/* Footer */}
        <AuthFooter />
      </div>
    </div>
  );
};
